import { useState, useEffect, useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { useLocation } from 'react-router-dom'
import styles from './PrintPreview.module.css'
import * as clientEventService from '../../../services/clientEventService'

const PrintPreview = () => {
    const location = useLocation()
    const passedState = location.state
    const [printData, setPrintData] = useState([])
    const [data, setData] = useState({})

    const componentRef = useRef()
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Print that stuff",
        onAfterPrint: () => alert("Print Success")
    })
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }

    useEffect(() => {
        if (data && data.clientId !== undefined && data.clientName) {
            setPrintData(data)
        }

    }, [data])
    useEffect(() => {
        // store into local object
        let localclientevent = clientEventService.getClientEvent()
        if (localclientevent) {
            setClientEventInfo(localclientevent)
            setData(localclientevent)
        }
    }, [])

    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    return (
        <div className={styles.printPage}>

            <h1>Badge Print Preview</h1>

            <button
                onClick={handlePrint}
                id={styles.printButton}
            >
                Print
            </button>

            <div className={styles.printArea} ref={componentRef}>
                {printData.length ?
                    printData.map((data, index) => (
                        <div className={styles.badgeContainer} key={index}>
                            <p className={styles.badgeLines} id={styles.firstName}>{data.firstName}</p>
                            <p className={styles.badgeLines} id={styles.lastName}>{data.lastName}</p>
                            <p className={styles.badgeLines} id={styles.company}>{data.organization}</p>
                        </div>
                    ))
                    :
                    <></>
                }
            </div>

        </div>
    );
}

export default PrintPreview;